import { render } from "./PodUpdate.vue?vue&type=template&id=15c1de8d&scoped=true"
import script from "./PodUpdate.vue?vue&type=script&lang=js"
export * from "./PodUpdate.vue?vue&type=script&lang=js"

import "./PodUpdate.vue?vue&type=style&index=0&id=15c1de8d&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c1de8d"]])

export default __exports__